var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 3.75c-.82 0-1.5.68-1.5 1.5v13.5c0 .82.68 1.5 1.5 1.5h13.5c.82 0 1.5-.68 1.5-1.5V5.25c0-.82-.68-1.5-1.5-1.5H5.25zm0 1.5h13.5v13.5h-3.89v-5.063h1.945l.28-2.25H14.86V9.985c0-.655.162-1.101 1.102-1.101h1.219v-2.04c-.208-.027-.93-.07-1.758-.07-1.728 0-2.906 1.04-2.906 2.977v1.688h-1.97v2.25h1.97v5.062H5.25V5.25z",
    fill: "currentColor"
  })));
};
export default SvgFacebook;